/* eslint-disable @typescript-eslint/no-explicit-any */
// Imports for external libraries go here.
import { FC } from 'react';
import { StyledSelectedFiltersBar } from './SelectedFiltersBar.styles';
import { selectedFiltersBarProps } from './SelectedFiltersBar.types';
import { Button, Icon } from '@marriott/mi-ui-library';
import { DisplayedFilter } from '../SearchResultsComponent.types';

export const SelectedFiltersBar: FC<selectedFiltersBarProps> = ({ filters, onRemoveFilter }) => {
  return (
    <StyledSelectedFiltersBar data-testid="luxury-SelectedFiltersBar" data-component-name="o-luxury-SelectedFiltersBar">
      {filters?.map((selectedFilter: DisplayedFilter) => (
        <Button className="mr-3 px-2 pl-3 selected-filter-button" key={selectedFilter?.id}>
          <span>{selectedFilter?.label}</span>
          <span className="t-font-s" onClick={() => onRemoveFilter(selectedFilter?.type, selectedFilter?.code)}>
            <Icon iconClass="icon-clear clear-button" ariaLabel="icon-clear" />
          </span>
        </Button>
      ))}
    </StyledSelectedFiltersBar>
  );
};
